/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAADEklEQVR4nMVVSWsUURDOQRNXokQRXE4SRS/eXRgUg43Tr6pmtKeqNWE04HhRD+pFg6LixRjBn6GIEhEX4oYJORmUgJcIKrlEYjRuAVEkker3OtMzTiYxFx80dHW/ru+r76tXXVPzP1cQBIuApBWQrxuUAYPyHYhHAfm1Ibmm73TPbBLXGpJTBuULkExUuwzJN93reV7djJKn08EqQ9znEowDcpdBPpDOho2+7y8IgmA+Ea9zlT0uAnEfIq+pmhxAVgLJYPQByoBP4dbpCCHyNt3rgAYzmf2rK24sFApzDfFzV/azIAjqbYL8EoNywpD0GuQhIB5TtgblvDGyYnIPSber5KVK/BeA6hgzj5P7GO6p5kP0LiPpBBFXCZ8tSa6d4BKNI/JmC8hZg/LbsboNkNsOAIvVA5ORHYByz4H8BBCICFGY0hyaKyZptSc5FCEjd2nsBcHyInNum9Iz4jYLwsNxQkPyRJ8hhocT8vANp30+KReg3IkAPa8OiDvUA3tJe6yzIb7rQM45sq3u284iE+Q3+pCI1zoAa1hGmhzTjgr6t9vOy+10lfbbOFjv9rxNljqmD+PDYpA/apxO71uajEsBeFjfEbU0uHhI46am5oUOcKQoUTQCZEINtBXJBxfXTwdgQXhD8iQj5nbF5OIWfRcxzoaNrqJ+J5HnCFyZSqIZLUC5WWIyykXXnkdcG9daH3gEUN4DyeVJkzPiGeIHOgSdEo+0Aj2YgNwTd1Eh2aaqq0E+XVJmxTaVC9MNw2ijah37YLK5LckkqVRqDkDuoHZW5AXIXqtzuNt58QuIj/t+uMwOSp3C+iwB4Iw847S9WjSvpSExWaMrncltcr49dN1yPOFlb8UKIqb5/DwdYADBRo21Kwzxi/IP4k4zKJ80VuZFL7mn7F/RPbW+GTlWSVMlYvXnUXs4Wxpm0EcVAFA6KwEkJHpaLtE/LcTQxMaXXnYU6wSNTfaRT+q/QYdkdE/8OW7xqkuPvSFpNsS3gPgVEH8F5PuTVRJfqvKvODqrysqXIUYd0VFrIv/Q7oongG74AyA9NH28X4f0AAAAAElFTkSuQmCC)
 */
export const StageRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16ZM12.78 22.22c.18.34-.02.76-.4.77L12 23c-1.74 0-3.4-.4-4.86-1.13a1.52 1.52 0 0 1-.8-1.84A6 6 0 0 1 12 16c.32 0 .52.34.4.64a6.99 6.99 0 0 0 .38 5.58ZM13.55 14.57a3.02 3.02 0 0 0 1.43-2.88 3 3 0 1 0-1.43 2.88Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M17.27 12.21A.22.22 0 0 1 17 12a5 5 0 1 0-9.6 1.94c.17.42.13.9-.18 1.23l-.05.06c-.43.47-1.18.42-1.45-.14a7 7 0 1 1 13.27-3.59c.01.28-.21.5-.49.52-.42.03-.83.1-1.23.2Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M21.27 12.38A.4.4 0 0 1 21 12a9 9 0 1 0-16.54 4.92c.27.42.26.97-.07 1.33l-.02.02c-.41.44-1.12.43-1.46-.07A11 11 0 1 1 23 11.5c.01.28-.22.5-.49.54-.32.05-.62.16-.9.3a.41.41 0 0 1-.33.04Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
